import {Component, OnInit, OnDestroy, Inject, DOCUMENT} from '@angular/core';
import {LocalStorageService, AuthEvent, Utilities, ServiceWorkerService, ServiceWorkerEvent} from '@xmedical/core';
import {Subscription} from 'rxjs';
import {CoreService} from './core/services/core.service';
import {CoreEvent, CoreEventsService} from './core/services/core-events.service';
import {AuthenticationService} from './core/auth/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  pwaEventSubscription: Subscription;
  coreEventsSubscription: Subscription;
  authEventsSubscription: Subscription;
  errorAlertVisible = false;
  updateAlertVisible = false;
  offlineAlertVisible = false;
  isAuthenticated = false;

  constructor(
    private authService: AuthenticationService,
    private localStorage: LocalStorageService,
    private pwaService: ServiceWorkerService,
    private coreService: CoreService,
    private coreEventService: CoreEventsService,
    @Inject(DOCUMENT) private doc: Document) {
  }

  ngOnInit(): void {
    this.pwaEventSubscription = this.pwaService.event$.subscribe(event => this.pwaEventHandler(event));
    this.coreEventsSubscription = this.coreEventService.events$.subscribe(event => this.coreEventsHandler(event));
    this.authEventsSubscription = this.authService.events$.subscribe(event => this.authEventsHandler(event));
    let installId = this.localStorage.getItem('installation_id');
    if (installId === null) {
      installId = Utilities.generateUuid();
      this.localStorage.setItem('installation_id', installId);
    }
    this.themeHandler();
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  reload() {
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.pwaEventSubscription?.unsubscribe();
    this.coreEventsSubscription?.unsubscribe();
    this.authEventsSubscription?.unsubscribe();
  }

  private authEventsHandler(event: AuthEvent) {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  private coreEventsHandler(event: CoreEvent) {
    if (event.type === 'connection_state_changed') {
      this.offlineAlertVisible = !this.coreService.online;
    }
    if (event.type === 'app_error') {
      this.errorAlertVisible = true;
    }
    if (event.type === 'user_settings_loaded') {
      this.themeHandler();
    }
  }

  private pwaEventHandler(event: ServiceWorkerEvent) {
    if (event === 'update_available') {
      this.updateAlertVisible = true;
    }
    if (event === 'sw_error') {
      this.errorAlertVisible = true;
    }
  }

  private themeHandler() {
    const currentTheme = this.coreService.settings()?.theme ?? '';
    const document = this.doc.documentElement;
    this.coreService.setTheme(document, currentTheme);
  }
}
